import { createDraftSafeSelector } from '@reduxjs/toolkit'

import { RootState } from 'src/Redux/index'

import { getClosedMetaAdsTypeformIds } from './index'

export const makeIsMetaAdsCampaignClosed = (
  campaignId: string,
): ((state: RootState) => boolean) =>
  createDraftSafeSelector([getClosedMetaAdsTypeformIds], (closedIds) =>
    Boolean(closedIds?.includes(campaignId)),
  )
